<template>
  <qx-card-form title="基础信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="mobilePhoneTip">
        <span
          style="margin-left: 16px;"
          :class="mobilePhoneTipCtrl.color"
          v-if="mobilePhoneTipCtrl.text"
        >{{mobilePhoneTipCtrl.text}}</span>
      </span>
      <span slot="linkmanTip" v-show="isRepeatName">
          <span style="color:red;margin-left: 16px;">存在重名司机，请仔细检查后录入！</span>
        </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  driverCheck, driverNameCheck,
} from 'api/archives';
import {mapState} from 'vuex';
export default {
  data () {
    return {
      isRepeatName: false, // 校验司机姓名是否重复
      mobilePhoneTipCtrl: {
        text: '',
        color: '',
      },
      otherFormData: {
        relId: '',
        tenantId: '',
        userInfo: {},
        vehicleList: [], // 车辆列表
        type: 1,
      },
      baseForm: {
        carUserTypeOptions: [], // 司机种类
        driverOwnerShipOptions: [], // 司机性质
        attachedOrgIdOptions: [],
        inline: true,
        form: [
          {
            label: '司机账号',
            value: 'mobilePhone',
            type: 'input',
            onChange: () => {
              this.handleMobileChange();
            },
            onInput: () => {
              this.handleMobileChange();
            },
          },
          {
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
            hide: false,
            onBlur: () => {
              this.handleLinkmanChange();
            },
          },
          {
            label: '司机种类',
            value: 'carUserType',
            type: 'select',
            onChange: () => {
              this.handleCarUserType();
            },
          },
          {
            label: '归属部门',
            value: 'attachedOrgId',
            type: 'select',
            hide: true,
          },
          {
            label: '司机性质',
            value: 'driverOwnerShip',
            type: 'select',
            hide: true,
          },
          // {
          //   label: '入职日期',
          //   value: 'entryDate',
          //   type: 'date',
          //   attr: {
          //     time: '00:00:00',
          //   },
          //   hide: false,
          // },
        ],
        rules: {
          mobilePhone: [ // 司机账号
            { required: true, message: '请输入司机账号', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
          carUserType: [ // 司机种类
            { required: true, message: '请选择司机种类', trigger: 'blur' },
          ],
          attachedOrgId: [ // 归属部门
            { required: true, message: '请选择归属部门', trigger: 'blur' },
          ],
          linkman: [ // 司机姓名
            { required: true, message: '请输入司机姓名', trigger: 'blur' },
          ],
          // entryDate: [ // 入职日期
          //   { required: true, message: '请选择入职日期', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    async handleMobileChange () { // 司机账号
      if (this.$route.query.id) {
        return;
      }
      const mobilePhone = this.$refs.baseForm.getVal('mobilePhone') || '';
      if (/^\d{11}$/.test(mobilePhone)) {
        const res = await driverCheck({
          loginAcct: mobilePhone,
        });
        if (!res.failed) {
          this.otherFormData.userInfo = res.userInfo;
          this.otherFormData.vehicleList = res.vehicleList;
          this.otherFormData.type = res.type;

          if (this.otherFormData.type === 1 || this.otherFormData.type === 4) {
            this.mobilePhoneTipCtrl = {
              text: '该手机号未注册',
              color: 'success',
            };
          }
          if (this.otherFormData.type === 2 || this.otherFormData.type === 3) {
            this.mobilePhoneTipCtrl = {
              text: '该手机号已注册',
              color: 'error',
            };
          }
          if (this.otherFormData.userInfo && this.otherFormData.userInfo.linkman) {
            this.$refs.baseForm.setVal('linkman', this.otherFormData.userInfo.linkman);
          }

          this.$emit('getOtherFormVal', {
            from: 'imgInfo',
            tar: 'baseForm',
          });
          this.$emit('getOtherFormVal', {
            from: 'belong',
            tar: 'baseForm',
          });
          this.$emit('getOtherFormVal', {
            from: 'salary',
            tar: 'baseForm',
          });
          this.$emit('getOtherFormVal', {
            from: 'tenant',
            tar: 'baseForm',
          });
          this.$emit('getOtherFormVal', {
            from: 'apply',
            tar: 'baseForm',
          });
        }
        this.hanldeFormItemShow();
      } else {
        // 将之前检测输出的内容全部清除掉
        this.mobilePhoneTipCtrl = {
          text: '',
          color: '',
        };
        this.$refs.baseForm.setVal('linkman', '');
      }
    },
    handleCarUserType () { // 司机种类
      this.$emit('getOtherFormVal', {
        from: 'apply',
        tar: 'baseForm',
      });
      this.$emit('getOtherFormVal', {
        from: 'belong',
        tar: 'baseForm',
      });
      this.$emit('getOtherFormVal', {
        from: 'imgInfo',
        tar: 'baseForm',
      });
      this.$emit('getOtherFormVal', {
        from: 'salary',
        tar: 'baseForm',
      });
      this.hanldeFormItemShow();
    },
    async handleLinkmanChange () {
      const linkman = this.$refs.baseForm.getVal('linkman');
      if (linkman !== '') {
        const res = await driverNameCheck({
          userName: linkman,
        });
        if (!res.failed) {
          if (res === 'Y') {
            this.isRepeatName = true;
          }
          if (res === 'N') {
            this.isRepeatName = false;
          }
        }
      } else {
        this.isRepeatName = false;
      }
      this.$emit('linkmanChange', this.$refs.baseForm.getVal('linkman'));
    },
    hanldeFormItemShow () {
      this.$nextTick(() => {
        const carUserType = this.$refs.baseForm.getVal('carUserType');
        const userInfoFlag = Boolean(this.otherFormData.userInfo);
        this.setFormAttrVal({ // 姓名
          form: this.baseForm,
          attr: 'hide',
          value: userInfoFlag,
          names: ['linkman'],
        });
        // this.setFormAttrVal({ // 入职日期
        //   form: this.baseForm,
        //   attr: 'hide',
        //   value: userInfoFlag && carUserType !== '1',
        //   names: ['entryDate'],
        // });
        this.setFormAttrVal({ // 司机性质
          form: this.baseForm,
          attr: 'hide',
          value: !(userInfoFlag && carUserType === '1'),
          names: ['driverOwnerShip'],
        });
        this.setFormAttrVal({ // 入职日期
          form: this.baseForm,
          attr: 'hide',
          value: carUserType !== '1',
          names: ['attachedOrgId'],
        });
        if (this.userInfo.staffTFInfo.tenantId === 2483) { // 2483测试车队陈的tenantId，默认展示“测试导入部门”
          let data = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11050).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11050)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
          this.$refs.baseForm.setVal('attachedOrgId', data);
        } else if (this.userInfo.staffTFInfo.tenantId === 2536) { // 2536福鹏的tenantId，默认展示“车辆与司机”
          let data = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11151).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11151)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
          this.$refs.baseForm.setVal('attachedOrgId', data);
        } else if (this.userInfo.staffTFInfo.tenantId === 2538) { // 2538单翠的tenantId，默认展示“测试部”
          let data = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11160).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11160)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
          this.$refs.baseForm.setVal('attachedOrgId', data);
        } else { // 其他车队，【归属部门】进来默认选中第一个
          this.$refs.baseForm.setVal('attachedOrgId', this.baseForm.attachedOrgIdOptions[0].value);
        }
      });
    },
    setList (carUserTypeOptions, driverOwnerShipOptions, attachedOrgIdOptions) {
      this.baseForm.carUserTypeOptions = carUserTypeOptions;
      this.baseForm.driverOwnerShipOptions = driverOwnerShipOptions;
      this.baseForm.attachedOrgIdOptions = attachedOrgIdOptions;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // formData.entryState = new Date(formData.entryDate) < new Date() ? 1 : 0;
        // if (formData.entryDate) {
        //   formData.entryDate = this.formatDate(formData.entryDate);
        // }
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.loginAcct = formData.mobilePhone;
        delete formData.userInfo;
        delete formData.vehicleList;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    init (data = {}) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: ['mobilePhone'],
      });
      this.mobilePhoneTipCtrl = {
        text: '',
        color: '',
      };
      this.$refs.baseForm.reset();
      data.carUserType = data.carUserType || this.baseForm.carUserTypeOptions[0].value;
      // data.entryDate = data.entryDate ? new Date(data.entryDate) : '';
      if (data.carUserType !== undefined) {
        data.carUserType = String(data.carUserType);
      }

      if (data.orgId === undefined || data.orgId === null) {
        // 新建状态，默认展示一个【归属部门】
        if (this.userInfo.staffTFInfo.tenantId === 2483) { // 2483测试车队陈的tenantId，默认展示“测试导入部门”
          data.attachedOrgId = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11050).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11050)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
        } else if (this.userInfo.staffTFInfo.tenantId === 2536) { // 2536福鹏的tenantId，默认展示“车辆与司机”
          data.attachedOrgId = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11151).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11151)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
        } else if (this.userInfo.staffTFInfo.tenantId === 2538) { // 2538单翠的tenantId，默认展示“测试部”
          data.attachedOrgId = this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11160).length > 0 ? this.baseForm.attachedOrgIdOptions.filter((item) => item.value === 11160)[0].value : this.baseForm.attachedOrgIdOptions[0].value;
        } else { // 其他车队，【归属部门】进来默认选中第一个
          data.attachedOrgId = this.baseForm.attachedOrgIdOptions[0].value;
        }
      }
      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
      this.handleMobileChange();
      this.handleCarUserType();
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.$emit('getBaseFormInfo', this.$refs.baseForm);
    });
  },
};
</script>

<style scoped lang="scss">
</style>
